import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getMachine } from 'lib/selectors/getMachine';
import useResyncMachineLaborTickets from 'lib/hooks/useResyncMachineLaborTickets';
import { dispatchNatsResponseActions } from 'lib/utils/handleNatsLaborTicketResponse';

const useHandleNatsLaborTicketResponse = () => {
  const dispatch = useDispatch();
  const machine = useSelector(getMachine);
  const resyncLaborTickets = useResyncMachineLaborTickets();

  return useCallback(
    async ({ response, options = {} }) => {
      const { laborTickets } = dispatchNatsResponseActions({
        response,
        dispatch,
        machine,
        options,
      });

      if (laborTickets.length > 0) {
        try {
          await resyncLaborTickets();
        } catch {
          // Let the subscription reconcile if immediate resync fails.
        }
      }

      return { laborTickets };
    },
    [dispatch, machine, resyncLaborTickets]
  );
};

export default useHandleNatsLaborTicketResponse;
